<div class="header-with-changers">
	<p-dropdown [options]="users" [(ngModel)]="selectedUser" (onChange)="somethingChanged()" optionLabel="name">
	</p-dropdown>

	<p-calendar [(ngModel)]="startDate" view="date" [tabindex]="-1" type="date" readonly="readonly" name="firstDate"
		placeholder="Date From" [showIcon]="true" [ngModelOptions]="{standalone: true}" [readonlyInput]="false"
		[showOnFocus]="false" (onSelect)="somethingChanged()">
	</p-calendar>

	<p-calendar [(ngModel)]="endDate" view="date" [tabindex]="-1" type="date" readonly="readonly" name="endDate"
		placeholder="Date To" [showIcon]="true" [ngModelOptions]="{standalone: true}" [readonlyInput]="false"
		[showOnFocus]="false" (onSelect)="somethingChanged()">
	</p-calendar>
</div>

<div class="body-tests" *ngIf="!loadingSpinner">
	<div class="table-body">
		<div class="ticket-row" style="font-weight: bold;">
			<div class="ticket-cell ticket-summary">
				<span class="texttt">Ticket Name</span>
			</div>
			<div class="ticket-cell ticket-summary">
				<span class="texttt">Test Ticket Name</span>
			</div>
			<div class="ticket-cell ticket-status">
				<span class="texttt">Priority</span>
			</div>
			<div class="ticket-cell ticket-status">
				<span class="texttt">Status</span>
			</div>
		</div>
		<div class="ticket-row" *ngFor="let ticket of ticketPage?.tickets">
			<div class="ticket-cell ticket-summary" (click)="openTicket(ticket.id)"
				[ngClass]="{'allow-to-click': ticket.id}">
				<span class="texttt">{{ticket.id}} | {{ticket.summary}}</span>
			</div>
			<div class="ticket-cell ticket-summary" (click)="openTicket(ticket.testTicket?.id)"
				[ngClass]="{'allow-to-click': ticket.testTicket?.id}">
				<span class="texttt" *ngIf="ticket.testTicket">{{ticket.testTicket?.id}} | {{ticket.testTicket?.summary}}</span>
			</div>
			<div class="ticket-cell ticket-status">
				<span class="texttt">{{ticket.testTicket?.priority.name}}</span>
			</div>
			<div class="ticket-cell ticket-status">
				<span class="texttt">{{ticket.testTicket?.status.name}}</span>
			</div>
		</div>
	</div>
</div>

<div class="body-tests" *ngIf="loadingSpinner">
	<lib-progress-spinner></lib-progress-spinner>
</div>